
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!conferences.concluded_conference";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'conferences/concludedConference';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <a class=\"ig-title element_toggler\"\n            href=\"#\"\n            aria-controls=\"conference-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n            aria-expanded=\"false\"\n            role=\"button\">\n          <i class=\"icon-mini-arrow-right auto_rotate\"></i>\n          ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        </a>\n      ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <span class=\"ig-title\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n      ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n          <div class=\"ig-details__item ig-details__item--wrap-text\">\n            ";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n          </div>\n        ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          <div class=\"ig-details__item-recordings ig-details__item-recordings--wrap-text\">\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.multipleRecordings), {hash:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </div>\n        ";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'recordingCount': ((depth0 && depth0.recordingCount)),
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "recordings", "%{recordingCount} Recordings", options) : helperMissing.call(depth0, "t", "recordings", "%{recordingCount} Recordings", options)))
    + "\n          ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "recording", "1 Recording", options) : helperMissing.call(depth0, "t", "recording", "1 Recording", options)))
    + "\n          ";
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <a class=\"al-trigger al-trigger-gray\" role=\"button\" aria-haspopup=\"true\" aria-owns=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-content-1\" href=\"#\">\n          <i class=\"icon-settings\"></i>\n          <i class=\"icon-mini-arrow-down\"></i>\n          <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "settings", "Settings", options) : helperMissing.call(depth0, "t", "settings", "Settings", options)))
    + "</span>\n        </a>\n        <ul id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-content-1\" class=\"al-options\" role=\"menu\" aria-hidden=\"true\" aria-expanded=\"false\" aria-activedescendant=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-content-2\">\n          <li role=\"presentation\">\n            <a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n                class=\"icon-trash  delete_conference_link\"\n                id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-content-3\"\n                role=\"menuitem\"\n                aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "delete", "Delete", options) : helperMissing.call(depth0, "t", "delete", "Delete", options)))
    + "\"\n                title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "delete", "Delete", options) : helperMissing.call(depth0, "t", "delete", "Delete", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "delete", "Delete", options) : helperMissing.call(depth0, "t", "delete", "Delete", options)))
    + "\n            </a>\n          </li>\n        </ul>\n      ";
  return buffer;
  }

function program14(depth0,data,depth1) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <div class=\"ig-sublist\" data-id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"conference-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" style=\"display: none;\">\n    <ul>\n      ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.recordings), {hash:{},inverse:self.noop,fn:self.programWithDepth(15, program15, data, depth0, depth1),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </ul>\n  </div>\n";
  return buffer;
  }
function program15(depth0,data,depth1,depth2) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <li class=\"recording\">\n          <div class=\"ig-row\" data-id=\"";
  if (helper = helpers.recording_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.recording_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" style=\"text-align: center;\">\n            <div class=\"ig-row__layout\">\n              <div class=\"ig-info\">\n                <div class=\"ig-details\">\n                  ";
  stack1 = helpers['if'].call(depth0, (depth2 && depth2.isAdobeConnect), {hash:{},inverse:self.programWithDepth(18, program18, data, depth1),fn:self.programWithDepth(16, program16, data, depth0, depth1),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  "
    + escapeExpression((helper = helpers.dateString || (depth0 && depth0.dateString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.created_at), options) : helperMissing.call(depth0, "dateString", (depth0 && depth0.created_at), options)))
    + "\n                  &nbsp;&#124;&nbsp;\n                  "
    + escapeExpression((helper = helpers.durationToString || (depth0 && depth0.durationToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.duration_minutes), options) : helperMissing.call(depth0, "durationToString", (depth0 && depth0.duration_minutes), options)))
    + "\n                </div>\n              </div>\n              ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth1 && depth1.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.manage_recordings), {hash:{},inverse:self.noop,fn:self.programWithDepth(25, program25, data, depth1),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </div>\n          </div>\n        </li>\n      ";
  return buffer;
  }
function program16(depth0,data,depth1,depth2) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                    <a id=\"adobe-connect-playback-link\" href=\""
    + escapeExpression(((stack1 = (depth1 && depth1.playback_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" target=\"_blank\" class=\"ig-title\"\n                      style=\"line-height: inherit;\" data-id=\""
    + escapeExpression(((stack1 = (depth2 && depth2.recording_id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-format=\"presentation\">\n                      ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n                    </a>\n                  ";
  return buffer;
  }

function program18(depth0,data,depth2) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                    <span>";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n                    &nbsp;&nbsp;&nbsp;\n                    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.playback_formats), {hash:{},inverse:self.noop,fn:self.programWithDepth(19, program19, data, depth2),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  ";
  return buffer;
  }
function program19(depth0,data,depth3) {
  
  var buffer = "", stack1;
  buffer += "\n                      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.show_to_students), {hash:{},inverse:self.programWithDepth(22, program22, data, depth0, depth3),fn:self.programWithDepth(20, program20, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                    ";
  return buffer;
  }
function program20(depth0,data,depth1) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                        <a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" target=\"_blank\" class=\"ig-title\"\n                          style=\"line-height: inherit;\" data-id=\""
    + escapeExpression(((stack1 = (depth1 && depth1.recording_id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-format=\"presentation\">\n                          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'type': ((depth0 && depth0.type)),
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "type", "%{type}", options) : helperMissing.call(depth0, "t", "type", "%{type}", options)))
    + "\n                        </a>\n                      ";
  return buffer;
  }

function program22(depth0,data,depth1,depth4) {
  
  var buffer = "", stack1;
  buffer += "\n                        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth4 && depth4.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.manage_recordings), {hash:{},inverse:self.noop,fn:self.programWithDepth(23, program23, data, depth1),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                      ";
  return buffer;
  }
function program23(depth0,data,depth2) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                          <a href=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" target=\"_blank\" class=\"ig-title\"\n                            style=\"line-height: inherit;\" data-id=\""
    + escapeExpression(((stack1 = (depth2 && depth2.recording_id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-format=\"presentation\">\n                            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'type': ((depth0 && depth0.type)),
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "type", "%{type}", options) : helperMissing.call(depth0, "t", "type", "%{type}", options)))
    + "\n                          </a>\n                        ";
  return buffer;
  }

function program25(depth0,data,depth2) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                <div class=\"ig-button\" data-id=\"";
  if (helper = helpers.recording_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.recording_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-action=\"delete\" data-url=\""
    + escapeExpression(((stack1 = (depth2 && depth2.url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n                  <a href=\"#\"\n                      class=\"btn btn-small icon-trash delete_recording_link\"\n                      title=\""
    + escapeExpression((helper = helpers.t || (depth2 && depth2.t),options={hash:{
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "delete", "Delete", options) : helperMissing.call(depth0, "t", "delete", "Delete", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth2 && depth2.t),options={hash:{
    'scope': ("conferences.concluded_conference")
  },data:data},helper ? helper.call(depth0, "delete", "Delete", options) : helperMissing.call(depth0, "t", "delete", "Delete", options)))
    + "\n                  </a>\n                </div>\n              ";
  return buffer;
  }

  buffer += "<div class=\"ig-row\" id=\"conf_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  <div class=\"ig-row__layout\">\n    <div class=\"ig-info\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.recording), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n      <div class=\"ig-details\">\n        <div class=\"ig-details__item\">\n          "
    + escapeExpression((helper = helpers.datetimeFormatted || (depth0 && depth0.datetimeFormatted),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.ended_at), options) : helperMissing.call(depth0, "datetimeFormatted", (depth0 && depth0.ended_at), options)))
    + "\n        </div>\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.description), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.recording), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n    <div class=\"ig-admin\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1['delete']), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  </div>\n</div>\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.recording), {hash:{},inverse:self.noop,fn:self.programWithDepth(14, program14, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  